import React from 'react';
import { Button } from './ui/Button';
import { Phone, Mail, MapPin, Facebook, Instagram, Youtube, Star, ChevronRight } from 'lucide-react';
export function Footer() {
  return <footer className="bg-background border-t border-border pt-20 pb-10" data-id="element-21">
      <div className="container mx-auto px-4" data-id="element-22">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-23">
          {/* Brand */}
          <div className="flex flex-col gap-6" data-id="element-24">
            <div className="flex items-center gap-3" data-id="element-25">
              <img src="https://cdn.magicpatterns.com/uploads/qgLYFiqJ263fT3C8koLsbm/logo.webp" alt="Drop Zone Cleanup Co." className="h-16 w-auto grayscale brightness-200" data-id="element-26" />
              <div className="flex flex-col" data-id="element-27">
                <span className="font-heading font-black text-xl tracking-tight leading-none uppercase text-foreground" data-id="element-28">
                  Drop Zone
                </span>
                <span className="text-primary font-bold text-sm tracking-widest uppercase" data-id="element-29">
                  Cleanup Co.
                </span>
              </div>
            </div>
            <p className="text-muted-foreground text-sm font-medium" data-id="element-30">
              Veteran-owned and operated junk removal and construction cleanup
              in Northeast Georgia. Your site, our mission.
            </p>
            <div className="flex items-center gap-4" data-id="element-31">
              <a href="https://www.facebook.com/DropZoneCleanUp" target="_blank" rel="noreferrer" className="w-10 h-10 rounded bg-secondary flex items-center justify-center text-foreground hover:bg-primary hover:text-primary-foreground transition-colors" data-id="element-32">
                <Facebook className="w-5 h-5" data-id="element-33" />
              </a>
              <a href="https://www.instagram.com/dropzonecleanup" target="_blank" rel="noreferrer" className="w-10 h-10 rounded bg-secondary flex items-center justify-center text-foreground hover:bg-primary hover:text-primary-foreground transition-colors" data-id="element-34">
                <Instagram className="w-5 h-5" data-id="element-35" />
              </a>
              <a href="https://www.yelp.com/biz/drop-zone-cleanup-winder" target="_blank" rel="noreferrer" aria-label="Yelp" className="w-10 h-10 rounded bg-secondary flex items-center justify-center text-foreground hover:bg-primary hover:text-primary-foreground transition-colors" data-id="element-36">
                <Star className="w-5 h-5" data-id="element-37" />
              </a>
              <a href="https://youtube.com/@DropZoneCleanUp" target="_blank" rel="noreferrer" aria-label="YouTube" className="w-10 h-10 rounded bg-secondary flex items-center justify-center text-foreground hover:bg-primary hover:text-primary-foreground transition-colors" data-id="element-38">
                <Youtube className="w-5 h-5" data-id="element-39" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-40">
            <h4 className="font-heading font-bold text-lg uppercase tracking-widest mb-6" data-id="element-41">
              Navigation
            </h4>
            <ul className="space-y-3" data-id="element-42">
              <li data-id="element-43">
                <a href="#services" className="text-muted-foreground hover:text-primary transition-colors uppercase text-sm font-bold tracking-wider" data-id="element-44">
                  Services
                </a>
              </li>
              <li data-id="element-45">
                <a href="#about" className="text-muted-foreground hover:text-primary transition-colors uppercase text-sm font-bold tracking-wider" data-id="element-46">
                  About Us
                </a>
              </li>
              <li data-id="element-47">
                <a href="#process" className="text-muted-foreground hover:text-primary transition-colors uppercase text-sm font-bold tracking-wider" data-id="element-48">
                  How It Works
                </a>
              </li>
              <li data-id="element-49">
                <a href="#faq" className="text-muted-foreground hover:text-primary transition-colors uppercase text-sm font-bold tracking-wider" data-id="element-50">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-51">
            <h4 className="font-heading font-bold text-lg uppercase tracking-widest mb-6" data-id="element-52">
              Contact HQ
            </h4>
            <ul className="space-y-4" data-id="element-53">
              <li className="flex items-start gap-3 text-muted-foreground" data-id="element-54">
                <MapPin className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-55" />
                <span className="text-sm font-medium" data-id="element-56">
                  76 W Candler St, Suite 6<br data-id="element-57" />
                  Winder, GA 30680
                </span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground" data-id="element-58">
                <Phone className="w-5 h-5 text-primary shrink-0" data-id="element-59" />
                <span className="text-sm font-medium" data-id="element-60">706-714-0156</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground" data-id="element-61">
                <Mail className="w-5 h-5 text-primary shrink-0" data-id="element-62" />
                <span className="text-sm font-medium" data-id="element-63">
                  info@dropzonecleanup.com
                </span>
              </li>
            </ul>
          </div>

          {/* CTA */}
          <div data-id="element-64">
            <h4 className="font-heading font-bold text-lg uppercase tracking-widest mb-6" data-id="element-65">
              Ready to Deploy?
            </h4>
            <p className="text-muted-foreground text-sm font-medium mb-4" data-id="element-66">
              Get a straightforward quote for your cleanup mission today.
            </p>
            <Button className="w-full uppercase font-bold tracking-wider group" data-id="element-67">
              Request Quote
              <ChevronRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-68" />
            </Button>
          </div>
        </div>

        <div className="border-t border-border pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-69">
          <p className="text-muted-foreground text-xs font-medium uppercase tracking-widest" data-id="element-70">
            &copy; {new Date().getFullYear()} Drop Zone Cleanup Co. All rights
            reserved.
          </p>
          <div className="flex items-center gap-4 text-xs font-medium text-muted-foreground uppercase tracking-widest" data-id="element-71">
            <a href="#" className="hover:text-primary transition-colors" data-id="element-72">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-primary transition-colors" data-id="element-73">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}